<template>
  <main-content>
    <div v-if="is_authenticated" class="w-100 bg-white notification px-4 py-4 mb-5">
      <div class="d-flex justify-content-lg-between align-items-lg-center flex-column flex-lg-row">
        <div>
          <div class="notification-header d-flex justify-content-between mb-3">
            <div class="d-flex flex-row align-items-center">
              <div class="notification-header_icon ml-3">
                <img src="../components/svg/alert.svg" width="24px" height="24px">
              </div>
              <div class="d-flex flex-column">
                <span class="mb-1">کاربران گرامی</span>
                <b>نسخه آزمایشی پنل جدید پی‌استار</b>
              </div>
            </div>
          </div>
          <p class="notification-desc">
              نسخه جدید پنل پی‌استار در مرحله آزمایش و بهبود قرار دارد. پیشنهاد می‌کنیم پس از تجربه نظرات خود را با ما به اشتراک بگذارید
          </p>
        </div>

        <div>
          <div class="d-flex justify-content-start">
            <a href="https://next.paystar.ir/login" class="btn notification-btn" size="md" type="button">
              ورود به پنل جدید
              <img src="../components/svg/arrow-left.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <page-title title_text="پیشخوان" icon="dashboard">

      <div v-if="is_authenticated">
        <select class="form-control" id="dashboard-data-select" v-model="type">
          <option value="pf" v-if="dashboard.user_data && dashboard.user_data['pf']">پرداخت‌یاری</option>
          <option value="collective" v-if="dashboard.user_data && dashboard.user_data['collective']">پرداخت یاری
          </option>
          <option value="ivr" v-if="dashboard.user_data && dashboard.user_data['ivr']"> تلفنی - پرداخت شناسه دار (درگاه
            ویژه)</option>
          <option value="dedicated" v-if="dashboard.user_data && dashboard.user_data['dedicated']">مستقیم (PSP)</option>
        </select>
      </div>
    </page-title>

    <user-wizard-setup
      v-if="!is_authenticated && current_user.status != userStatus.ENAMAD_AUTHENTICATED && user_status == 'success'"></user-wizard-setup>
    <user-wizard-namad
      v-if="current_user.status === userStatus.ENAMAD_AUTHENTICATED && !is_authenticated && user_status == 'success'" />

    <div class="row mt-4" v-if="current_user.status !== userStatus.ENAMAD_AUTHENTICATED">
      <div class="col-6 col-md my-2">
        <dashboard-box title="گردش مالی امروز" :number="status == 'success' ? dashboard.user_data[type].today_tr : 0"
          color="#FF8D8D" :has_rail="true">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
          </svg>
        </dashboard-box>
      </div>
      <div class="col-6 col-md my-2">
        <dashboard-box title="موجودی قابل برداشت" info="با کسر کارمزد"
          :number="status == 'success' ? dashboard.user_data[type].balance : 0" color="#00bea5" :has_rail="true">
          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
            fill="#fff" width="24">
            <g>
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <g>
                <rect height="7" width="3" x="4" y="10" />
                <rect height="7" width="3" x="10.5" y="10" />
                <rect height="3" width="20" x="2" y="19" />
                <rect height="7" width="3" x="17" y="10" />
                <polygon points="12,1 2,6 2,8 22,8 22,6" />
              </g>
            </g>
          </svg>
        </dashboard-box>
      </div>
      <div class="col-6 col-md my-2">
        <dashboard-box title="گردش مالی کل" :number="status == 'success' ? dashboard.user_data[type].total_tr : 0"
          color="#FF8D8D" :has_rail="true">
          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
            fill="#fff" width="24">
            <g>
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29
                  c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03
                  c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67
                  c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45
                   C15.9,17.17,13.4,17.67,12.88,17.76z" />
            </g>
          </svg>
        </dashboard-box>
      </div>
      <div class="col-6 col-md my-2">
        <dashboard-box title=" امتیاز باشگاه مشتریان" info="پلن باشگاه مشتریان"
          :number="status == 'success' ? dashboard.user_data.club_score : 0" color="#00bea5">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="#fff" width="24">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
        </dashboard-box>
      </div>
    </div>

    <div class="row mt-4" v-if="is_authenticated">
      <div class="col-12 col-lg-5 my-3">
        <recent-settlements></recent-settlements>
      </div>
      <div class="d-none d-lg-block col-lg-7 my-3" v-if="status == 'success' && tr_empty_days != 30">
        <chart
          :chart_data="type == 'collective' ? dashboard.user_data.collective_tr_chart : dashboard.user_data.pf_tr_chart">
        </chart>
      </div>
      <div class="d-none d-lg-block col-lg-7 my-3" v-else-if="status == 'success' && tr_empty_days == 30">
        <chart-empty :status="'success'"></chart-empty>
      </div>
      <div class="d-none d-lg-block col-lg-7 my-3" v-else-if="status == 'loading'">
        <chart-empty :status="'loading'"></chart-empty>
      </div>

      <div class="col-12 col-lg-12 my-3">
        <recent-transactions></recent-transactions>
      </div>

      <!--      <div class="col-12 col-lg-4 my-3">-->
      <!--        <pardakht-shakhsi></pardakht-shakhsi>-->
      <!--      </div>-->
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import { mapGetters } from "vuex";
import DashboardBox from "@/pages/dashboard/dashboard-box";
import RecentSettlements from "@/pages/dashboard/recent-settlements";
import RecentTransactions from "@/pages/dashboard/recent-transactions";
import PardakhtShakhsi from "@/pages/dashboard/pardakht-shakhsi";
import UserWizardSetup from "@/pages/dashboard/user-wizard-setup";
import Chart from "@/pages/dashboard/chart";
import ChartEmpty from "@/pages/dashboard/chart_empty";
import PageTitle from "@/components/main/components/pageTitle";
import UserWizardNamad from "./dashboard/user-wizard-namad.vue";
import { userStatus } from "../constants/userStatus";
export default {
  name: "dashboard",
  components: {
    UserWizardNamad,
    PageTitle,
    Chart,
    PardakhtShakhsi,
    RecentTransactions,
    RecentSettlements,
    DashboardBox,
    MainContent,
    UserWizardSetup,
    ChartEmpty,
  },
  data() {
    return {
      show_pardakht_shakhsi: false,
      empty_days: 0,
      collective_empty_days: 0,
      type: 'pf',
      isNotificationOpen: true,
      userToken: localStorage.getItem("access_token"),
      userData: localStorage.getItem("user")
    };
  },
  computed: {
    userStatus() {
      return userStatus
    },
    ...mapGetters("dashboard", ["dashboard", "status"]),
    ...mapGetters("user", ["is_authenticated", 'current_user', 'user_status']),

    tr_empty_days() {
      if (this.type == 'collective') {
        return this.collective_empty_days;
      }

      return this.empty_days;
    },
  },
  mounted() {
    this.$store.dispatch("dashboard/fetchDashboard").then(() => {
      for (let item in this.dashboard.user_data.pf_tr_chart.succeeded) {
        if (this.dashboard.user_data.pf_tr_chart.succeeded[item][1] == 0) {
          ++this.empty_days;
        }
      }

      for (let item in this.dashboard.user_data.collective_tr_chart.succeeded) {
        if (this.dashboard.user_data.collective_tr_chart.succeeded[item][1] == 0) {
          ++this.collective_empty_days;
        }
      }

      setTimeout(() => {
        if (this.dashboard.user_data['pf'].today_tr == '۰' && this.dashboard.user_data['collective'].today_tr != '۰') {
          this.type = 'collective';
        }
      }, 2000);
    });
  },
};
</script>

<style scoped>
.notification {
  border-radius: 20px;
  background-color: rgba(252, 212, 116, 0.5) !important;
  color: rgba(18, 44, 52, 1);
}

.notification-header>div span {
  font-size: 14px;
  color: rgba(18, 44, 52, 0.7);
}

.notification-header b {
  font-size: 14px;
  color: rgba(18, 44, 52, 1);
}


.notification-header .notification-header_icon {
  border: 2px solid #FCD474;
  border-radius: 100%;
  background-color: white;
  padding: 8px;
}

.notification-header>button {
  padding: 0px !important;
  font-size: 16px;
  height: 20px;
  width: 20px;
  padding-top: 2px !important;
  padding-left: 1px !important;
  color: rgba(18, 44, 52, 0.7);
  border-color: rgba(18, 44, 52, 0.7) !important;
}

.notification-header>button:hover {
  color: var(--danger) !important;
  border-color: var(--danger) !important;
  cursor: pointer;
}

.notification-desc {
  font-size: 14px;
  text-align: justify;
  color: rgba(18, 44, 52, 0.7);
}

.notification-btn {
  font-size: 14px;
  color: rgba(18, 44, 52, 0.7);
}
</style>
